import orderStatuses from '@/helpers/orderStatuses'
export default function () {
  return {
    page: 1,
    totalPages: 0,
    perPage: 15,
    searchParams: {},
    payables: [],
    commissionPercent: null,
    orderStatuses,
    fields: [
      {
        key: 'trip',
        label: 'Pedido'
      },
      {
        key: 'amount',
        label: 'Valor a receber'
      },
      {
        key: 'paymentDate',
        label: 'Previsão pagamento'
      },
      {
        key: 'order.status',
        label: 'Status pedido'
      },
      {
        key: 'status',
        label: 'Status'
      },
      {
        key: 'paidOn',
        label: 'Enviado em'
      }
    ]
  }
}
